import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex cos-both-form-item" }
const _hoisted_2 = {
  key: 0,
  class: "tips"
}

import { ref, reactive, toRaw, computed, onBeforeMount, watchEffect, unref } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import { goBack } from '@/hooks/cosRouter'
import { message } from '@dc-platform/dc-components'
import { selectForNumberValidate } from '@/utils/validate'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { listByParamCodes } from '@/api/common'
import { oaReviewStatus } from '@/views/overseasSales/commonEnum/dataConfig'
import {
  activityCreateAndSubmit,
  activityOAUpdate,
  activityDetail,
  templateList,
  activitySaveDraft
} from '@/api/marketing/marketingManage'
import { paramCodesDataFilter, downloadFileByBase64 } from '@/utils/index'
import type { FormInstance } from 'ant-design-vue'
import type { ParamCodeItem } from '@/typings/common'
import UploadFile from '@/components/UploadFile'
import { useI18n } from 'vue-i18n'
import CosTable from '@/components/CosTable/src/cosTable.vue'
import { newClientEvaluationReviewHistory } from '@/api/overseasSales/newClientEvaluation'

const __default__ = { name: 'DetailForm' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    type: {},
    subdomain: {},
    title: {},
    paramCode: {}
  },
  setup(__props: any) {

const { t } = useI18n()

const statusEnum = computed(() => [
  { name: t('marketing.可用'), value: true, color: '#3FAC46' },
  { name: t('marketing.不可用'), value: false, color: '#DF443B' }
])
const props = __props
watchEffect(() => {
  if (props.type === 'view' && props.subdomain == null) {
    console.error('当详情页时, props subdomain 必传')
  }
})

const exportTemple = () => {
  const eleLink = document.createElement('a')
  eleLink.download = window.API_URL + '/zbu/api/activity/qrcode/template/download'
  eleLink.style.display = 'none'
  eleLink.href = window.API_URL + '/zbu/api/activity/qrcode/template/download'
  document.body.appendChild(eleLink)
  eleLink.click()
  document.body.removeChild(eleLink)
}

const permissionPage = computed(() => {
  const addPermissions = {
    fbu: { save: 'fbu_activity_add_btn' },
    lbu: { save: 'lbu_activity_add_btn' },
    ofbu: { save: 'ofbu_activity_add_btn' }
  }
  const otherPermissions = {
    fbu: { edit: 'fbu_activity_edit_btn', save: 'fbu_activity_edit_btn' },
    lbu: { edit: 'lbu_activity_edit_btn', save: 'lbu_activity_edit_btn' },
    ofbu: { edit: 'ofbu_activity_edit_btn', save: 'ofbu_activity_edit_btn' }
  }
  return props.type === 'add' ? addPermissions[props.subdomain] : otherPermissions[props.subdomain]
})
const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  [props.paramCode]: [] // 来源渠道
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: [props.paramCode, 'ofbu_currency']
  }).then((res) => {
    if (props.type !== 'view') {
      // 递归过滤业务参数状态
      res.data = paramCodesDataFilter(res.data, 0)
    }
    paramCodeData.value = res.data
  })
}
// const partnerEnum = ref()
// const getPartner = () => {
//   partnerDropList().then((res) => {
//     partnerEnum.value = res.data
//   })
// }
const templateEnum = ref<any[]>([])
const pageUtils = reactive({ pageNumber: 1, pageSize: 100 })
const getTemplate = () => {
  templateList(pageUtils).then((res) => {
    templateEnum.value = [...templateEnum.value, ...res.data.items]
  })
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageUtils.pageNumber = pageUtils.pageNumber + 1
    getTemplate()
  }
}
onBeforeMount(() => {
  getByParamCodes()
  // getPartner()
  getTemplate()
})

const loading = ref(false)
const formRef = ref<FormInstance>()
const queryId = computed(() => route.query.id as string)
const initForm = ref<any>({
  activityName: undefined,
  channelId: undefined,
  follower: undefined,
  startTime: undefined,
  endTime: undefined,
  partnerId: undefined,
  activityTemplateId: undefined,
  remark: undefined
})
const dataForm = ref({})
const formRules = reactive({
  input: [{ required: true, message: t('common.pleaseInput') }],
  select: [{ required: true, message: t('common.pleaseSelect') }],
  selectNumber: [{ required: true, validator: selectForNumberValidate }]
})
const reviewHistoryColumns = computed(() => [
  {
    title: t('common.operator'),
    dataIndex: 'operatorName'
  },
  {
    title: t('common.operatorDate'),
    dataIndex: 'createTime',
    type: 'time'
  },
  {
    title: t('marketing.审核意见'),
    dataIndex: 'processSuggject',
    ellipsis: false
  }
])
const reviewHistory = ref<any[]>([])
const fetchReviewHistory = async (oaId: number) => {
  const res = await newClientEvaluationReviewHistory({ id: oaId })
  reviewHistory.value = res.data
}
const route = useRoute()
const getDetails = () => {
  loading.value = true
  activityDetail({ activityQrcodeId: route.query.id as string })
    .then((res) => {
      if (props.type === 'edit') {
        res.data.activityQrcodeId = res.data.id
      } else if (props.type === 'view') {
        fetchReviewHistory(res.data.oaId)
      }
      // Object.assign(initForm, res.data)
      // Object.assign(dataForm, res.data)
      // console.log('dataForm:', dataForm.value)
      dataForm.value = res.data
    })
    .finally(() => {
      loading.value = false
    })
}
onBeforeMount(() => {
  if (props.type !== 'add') {
    getDetails()
  }
})

const skipReview = computed(() => route.query.skipReview === '1')
const isSubmit = computed(() => route.query.isSubmit === '1')

const handleSubmitAdd = async () => {
  const v = await formRef.value?.validate()
  if (!v) return
  loading.value = true
  const p = dataForm.value
  p.skipReview = skipReview
  activityCreateAndSubmit(p)
    .then(() => {
      message.success(route.query.isSubmit === '1' ? t('marketing.提交市场活动成功') : t('marketing.新增市场活动成功'))
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}
const handleSubmitEdit = () => {
  loading.value = true
  const p = dataForm.value
  p.skipReview = skipReview
  activityOAUpdate(p)
    .then(() => {
      message.success(t('marketing.修改市场活动成功'))
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}

const handleSaveDraft = () => {
  loading.value = true
  const p = dataForm.value
  p.skipReview = skipReview
  activitySaveDraft(p)
    .then(() => {
      message.success(t('marketing.保存市场活动成功'))
      goBack()
    })
    .finally(() => {
      loading.value = false
    })
}

const onSubmit = (isEdit = false) => {
  if (isEdit) {
    handleSaveDraft()
  // } else if (props.type === 'edit') {
  //   handleSubmitEdit()
  // } else if (props.type === 'add' || route.query.isSubmit === '1') {
  } else {
    handleSubmitAdd()
  }
}

// const qrCodeRef = ref()
// const qrCodeTitle = ref('')
// const visible = ref<boolean>(false)
// const currentRow = ref()
// const qrCodeType = ref<'zh-CN' | 'en-US'>()
// const qrCodeUrl = ref('')
// const qrCodeLogoEnum = {
//   fbu: require('@/assets/logo_gucang.png'),
//   lbu: require('@/assets/logo_yuntu.png')
// }
// const handleCopy = () => {
//   clipboardRef.value = qrCodeUrl.value
//   if (unref(copiedRef)) {
//     message.success('复制成功')
//   } else {
//     message.error('该浏览器不支持自动复制!')
//   }
// }
// const showModal = (lang: 'zh-CN' | 'en-US', row: any) => {
//   const langEnum = { 'zh-CN': '中文二维码', 'en-US': '英文二维码' }
//   qrCodeType.value = lang
//   qrCodeTitle.value = langEnum[lang]
//   currentRow.value = row
//   qrCodeUrl.value = `${window.WEB_URL}/mobile.html#/businessCard?cardId=${row.id}&follower=${row.follower}&subdomain=${props.subdomain}&lang=${qrCodeType.value}`
//   visible.value = true
// }
// const handleOk = () => {
//   downloadFileByBase64(qrCodeRef.value.imgUrl, `${currentRow.value?.followerName}-${qrCodeType.value}`)
//   visible.value = false
// }

return (_ctx: any,_cache: any) => {
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_CosInputNumber = _resolveComponent("CosInputNumber")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      model: dataForm.value,
      autocomplete: "off",
      scrollToFirstError: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: props.title,
          span: 6
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('marketing.活动名称'),
              name: "activityName",
              rules: formRules.input
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.value.activityName,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.activityName) = $event)),
                  maxlength: 100,
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('marketing.来源渠道'),
              name: "channelId",
              rules: formRules.select
            }, {
              default: _withCtx(() => [
                _createVNode(ParamCodeCascader, {
                  value: dataForm.value.channelId,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.channelId) = $event)),
                  options: paramCodeData.value[props.paramCode],
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('marketing.活动负责人'),
              name: "follower",
              rules: formRules.select
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  value: dataForm.value.follower,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.follower) = $event)),
                  disabled: props.type === 'view',
                  view: props.type === 'view',
                  allowClear: ""
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('marketing.活动时间'),
              name: "startTime",
              rules: formRules.select
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosRangePicker, {
                  startTime: dataForm.value.startTime,
                  "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.value.startTime) = $event)),
                  endTime: dataForm.value.endTime,
                  "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.value.endTime) = $event)),
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["startTime", "endTime", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('marketing.选择模板'),
              name: "activityTemplateId",
              rules: formRules.select
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: dataForm.value.activityTemplateId,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.value.activityTemplateId) = $event)),
                  fieldNames: { label: 'name', value: 'id' },
                  options: templateEnum.value,
                  disabled: props.type === 'view',
                  view: props.type === 'view',
                  onPopupScroll: popupScroll,
                  allowClear: ""
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('marketing.活动地点'),
              name: "eventAddress",
              rules: formRules.input
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosInput, {
                  value: dataForm.value.eventAddress,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.value.eventAddress) = $event)),
                  maxlength: 256,
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (props.type !== 'view')
              ? (_openBlock(), _createBlock(_component_a_col, {
                  key: 0,
                  span: 6
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_a_form_item, {
                        style: {"width":"70%"},
                        label: _unref(t)('marketing.活动预算'),
                        name: "eventBudge",
                        rules: [{ required: true, message: _unref(t)('common.pleaseInput') }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInputNumber, {
                            value: dataForm.value.eventBudge,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.value.eventBudge) = $event)),
                            maxlength: 15,
                            min: 0,
                            controls: false,
                            view: props.type === 'view',
                            cosType: "money",
                            formatter: (inputValue) => `${inputValue}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                            parser: (inputValue) => inputValue.replace(/\$\s?|(,*)/g, '')
                          }, null, 8, ["value", "view", "formatter", "parser"])
                        ]),
                        _: 1
                      }, 8, ["label", "rules"]),
                      _createVNode(_component_a_form_item, {
                        label: "annualSalesUnit",
                        style: {"width":"30%"},
                        name: "eventBudgeCurrency",
                        class: "hide-label",
                        rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            options: paramCodeData.value.ofbu_currency,
                            value: dataForm.value.eventBudgeCurrency,
                            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.value.eventBudgeCurrency) = $event)),
                            view: props.type === 'view'
                          }, null, 8, ["options", "value", "view"])
                        ]),
                        _: 1
                      }, 8, ["rules"])
                    ])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  label: _unref(t)('marketing.活动预算'),
                  name: "eventBudgeCurrency",
                  rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ParamCodesSelect, {
                      cosBeforeDes: dataForm.value.eventBudge?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                      options: paramCodeData.value.ofbu_currency,
                      value: dataForm.value.eventBudgeCurrency,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.value.eventBudgeCurrency) = $event)),
                      view: props.type === 'view'
                    }, null, 8, ["cosBeforeDes", "options", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label", "rules"])),
            (props.type === 'view')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 2,
                  label: _unref(t)('follow.createByName'),
                  name: "createBy"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UserSelect, {
                      value: dataForm.value.createBy,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.value.createBy) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (props.type === 'view')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 3,
                  label: _unref(t)('business.wwys5u'),
                  name: "createTime"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.value.createTime,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.value.createTime) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (props.type === 'view')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 4,
                  label: _unref(t)('custom.申请单号'),
                  name: "oaApplyNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosInput, {
                      value: dataForm.value.oaApplyNo,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.value.oaApplyNo) = $event)),
                      view: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (props.type === 'view')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 5,
                  name: "enableFlag",
                  label: _unref(t)('operate.lbczwf')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      fieldNames: { label: 'name' },
                      value: dataForm.value.enableFlag,
                      "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.value.enableFlag) = $event)),
                      view: "",
                      options: statusEnum.value
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (props.type === 'view')
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 6,
                  label: _unref(t)('clue.审核状态')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CosSelect, {
                      value: dataForm.value.oaAuditStatus,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.value.oaAuditStatus) = $event)),
                      options: _unref(oaReviewStatus),
                      view: ""
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('common.remark'),
              name: "remark",
              span: 12
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosTextarea, {
                  value: dataForm.value.remark,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.value.remark) = $event)),
                  maxlength: 2000,
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_a_col, { span: 24 }),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('follow.UploadAttachments'),
              name: "otherFile",
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(UploadFile), {
                  value: dataForm.value.otherFile,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.value.otherFile) = $event)),
                  valueType: "array",
                  disabled: props.type === 'view',
                  view: props.type === 'view'
                }, null, 8, ["value", "disabled", "view"]),
                (props.type !== 'view')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_unref(t)('tips.templeDown')) + " : ", 1),
                        _createVNode(_component_a_button, {
                          style: {"padding":"0"},
                          type: "link",
                          primary: "",
                          onClick: exportTemple
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Example of Global Expo Budget Plan.xlsx ")
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["title"]),
        (props.type === 'view')
          ? (_openBlock(), _createBlock(_component_dc_layout_card, {
              key: 0,
              title: _unref(t)('marketing.审核记录'),
              span: 6
            }, {
              default: _withCtx(() => [
                _createVNode(CosTable, {
                  columns: reviewHistoryColumns.value,
                  style: {"padding":"0 6px 6px 6px"},
                  needPage: false,
                  "data-source": reviewHistory.value,
                  serial: "",
                  rowKey: "nodeId",
                  tableId: "marketingActivityCodeReviewHistory",
                  dynamicColumnSetting: false
                }, null, 8, ["columns", "data-source"])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_cos_footer_button, {
      value: dataForm.value,
      "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((dataForm).value = $event)),
      formRef: formRef.value,
      resetValue: initForm.value,
      loading: loading.value,
      disabled: props.type === 'view',
      permissionPage: permissionPage.value,
      editUrl: `/${props.subdomain}/activityCode/edit?id=${queryId.value}`,
      hideOk: ""
    }, {
      default: _withCtx(() => [
        (props.type !== 'view' && !skipReview.value && !isSubmit.value)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              type: "primary",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (onSubmit(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.saveOaDraft')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (props.type !== 'view')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              type: "primary",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (onSubmit()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('btn.save&Submit')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["value", "formRef", "resetValue", "loading", "disabled", "permissionPage", "editUrl"])
  ], 64))
}
}

})